import { Box, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Control } from 'react-hook-form'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { placeNames } from '../../../../../helpers/globalVariables'
import { getComp } from '../../../../../utils/utils/DI'
import FormAutocomplete from '../elements/FormAutocomplete'
import FormInput from '../elements/FormInput'
import TypedAccordion from '../elements/TypedAccordion'
import { BaseOptionType, ChangeInfoFormType } from '../helpers/getFormSchema'
import { dotationImageSx } from '../styles/styles'
import FormSelect from './FormSelect'
import InputLabel from './InputLabel'

type ChangeInfoFormProps = {
  control: Control<ChangeInfoFormType>
  districtOptions: any
  localitiesOptions: any
  fullDotationRegions: string[]
  inReportEditStatus: boolean
  withDotationImage: boolean
  territory: string | null
  categoriesItems: BaseOptionType[]
  onCategoriesChange: (value: BaseOptionType) => void
  onTerritoryChange: () => void
  onDistrictChange: () => void
}

const ChangeInfoForm: React.FC<ChangeInfoFormProps> = ({
  control,
  districtOptions,
  localitiesOptions,
  fullDotationRegions,
  inReportEditStatus,
  withDotationImage,
  territory,
  categoriesItems,
  onCategoriesChange,
  onDistrictChange,
  onTerritoryChange,
}) => {
  const territoryStore = getComp('TerritoryStore')

  return (
    <TypedAccordion summary={'Данные абонента'}>
      <Stack spacing={'10px'}>
        <InputLabel label='Фамилия'>
          <FormInput
            control={control}
            fullWidth
            name='surname'
            placeholder='Введите фамилию'
            capitalizeFirstLetter
          />
        </InputLabel>
        <InputLabel label='Имя'>
          <FormInput
            control={control}
            fullWidth
            name='name'
            placeholder='Введите имя'
            capitalizeFirstLetter
          />
        </InputLabel>
        <InputLabel label='Отчество'>
          <FormInput
            control={control}
            fullWidth
            name='patronymic'
            placeholder='Введите отчество'
            capitalizeFirstLetter
          />
        </InputLabel>
        <InputLabel label='Телефон'>
          <FormInput
            control={control}
            fullWidth
            name='phone'
            placeholder='Введите номер телефона'
            mask={'+7 (999)-999-99-99'}
          />
        </InputLabel>
        <InputLabel label='Регион'>
          <FormSelect
            control={control}
            fullWidth
            name='territory'
            items={territoryStore.collection as string[]}
            placeholder='Выберите регион'
            error={!territoryStore.collection.includes(territory)}
            onChange={onTerritoryChange}
          />
        </InputLabel>
        <InputLabel label='Округ'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='district'
            options={districtOptions}
            placeholder='Выберите округ'
            freeSolo
            withUnknownValueError
            onChange={onDistrictChange}
          />
        </InputLabel>
        <InputLabel label='населённый пункт'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='locality'
            options={localitiesOptions}
            placeholder='Выберите населённый пункт'
            fullDotationRegions={fullDotationRegions}
            freeSolo
            withUnknownValueError
          />
          {withDotationImage && (
            <Box sx={dotationImageSx}>
              <img src={getImageSrc('full-subsidy')} alt='full subsidy icon' />
            </Box>
          )}
        </InputLabel>
        <InputLabel label='Топоним'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='addressType'
            options={placeNames}
            withoutTyping
            placeholder='Выберите топоним'
            freeSolo
          />
        </InputLabel>
        <InputLabel label='Наименование топонима'>
          <FormInput
            control={control}
            fullWidth
            name='address'
            placeholder='Наименование топонима'
          />
        </InputLabel>
        <Stack direction={'row'} spacing={'10px'} maxWidth={'100%'}>
          <InputLabel label='дом'>
            <FormInput
              control={control}
              fullWidth
              name='house'
              placeholder='Дом'
              onlyNumbers
            />
          </InputLabel>
          <InputLabel label='корпус'>
            <FormInput
              control={control}
              fullWidth
              name='building'
              placeholder='Корпус'
              onlyNumbersAndLetters
            />
          </InputLabel>
          <InputLabel label='квартира'>
            <FormInput
              control={control}
              fullWidth
              name='apartment'
              placeholder='Квартира'
              onlyNumbers
            />
          </InputLabel>
        </Stack>
        <InputLabel label='Льготная категория'>
          <FormInput
            control={control}
            fullWidth
            name='preferentialCategory'
            placeholder='Введите категорию'
          />
        </InputLabel>
        <InputLabel label='Льготные категории'>
          <FormSelect
            control={control}
            fullWidth
            items={categoriesItems}
            name='categories'
            placeholder='Выберите категории'
            multiple
            onChange={onCategoriesChange}
            disableDefaultOnChange
          />
        </InputLabel>
        {inReportEditStatus && (
          <Stack spacing={'10px'} padding={'10px 0 0 0'}>
            <FormInput
              control={control}
              name='updateComment'
              multiline
              rows={3}
              fullWidth
              defaultError
              placeholder={'Введите комментарий'}
            />
          </Stack>
        )}
      </Stack>
    </TypedAccordion>
  )
}

export default observer(ChangeInfoForm)
